var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6902 6.71106C20.2749 6.71106 21.7946 7.34055 22.9151 8.46106C24.0356 9.58156 24.6651 11.1013 24.6651 12.6859C24.6651 14.2706 24.0356 15.7903 22.9151 16.9108C21.7946 18.0313 20.2749 18.6608 18.6902 18.6608C17.1056 18.6608 15.5859 18.0313 14.4653 16.9108C13.3448 15.7903 12.7153 14.2706 12.7153 12.6859C12.7153 11.1013 13.3448 9.58156 14.4653 8.46106C15.5859 7.34055 17.1056 6.71106 18.6902 6.71106ZM18.6902 9.69849C17.8979 9.69849 17.138 10.0132 16.5778 10.5735C16.0175 11.1337 15.7028 11.8936 15.7028 12.6859C15.7028 13.4782 16.0175 14.2381 16.5778 14.7984C17.138 15.3586 17.8979 15.6734 18.6902 15.6734C19.4825 15.6734 20.2424 15.3586 20.8027 14.7984C21.3629 14.2381 21.6777 13.4782 21.6777 12.6859C21.6777 11.8936 21.3629 11.1337 20.8027 10.5735C20.2424 10.0132 19.4825 9.69849 18.6902 9.69849ZM18.6902 20.1545C22.6784 20.1545 30.64 22.1412 30.64 26.1294V30.6105H6.74048V26.1294C6.74048 22.1412 14.702 20.1545 18.6902 20.1545ZM18.6902 22.9926C14.2539 22.9926 9.57854 25.1734 9.57854 26.1294V27.7725H27.8019V26.1294C27.8019 25.1734 23.1266 22.9926 18.6902 22.9926Z",
    fill: "#3D64E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.92c2b9aa73aa9aa31aafd76af247e159.svg";
export { ForwardRef as ReactComponent };